import React from "react";
import { motion } from "framer-motion";

import { fadeIn } from "../variants";

import { objectiveData } from "../data";

const Objective = () => {
  const { title, dividerImg, objective, message } = objectiveData;
  return (
    <section className="bg-testimonial bg-cover bg-no-repeat relative top-[340px] lg:top-[340px] z-10 h-[780px] lg:h-[600px] pt-[32px] md:pt-[120px]">
      <div className="container mx-auto">
        <motion.div
          variants={fadeIn("down", "tween", 0.6, 1.6)}
          initial="hidden"
          whileInView={"show"}
          className="container mx-auto flex flex-col items-center text-center"
        >
          <h2 className="h2 capitalize text-white max-w-[400px] text-center">
            {title}
          </h2>
          <p className="text-white">{objective}</p>
        </motion.div>
        <motion.div
          variants={fadeIn("down", "tween", 0.6, 1.6)}
          initial="hidden"
          whileInView={"show"}
          className="flex justify-center items-center mt-4"
        >
          <img src={dividerImg} alt="divider" />
        </motion.div>
        <motion.div
          variants={fadeIn("down", "tween", 0.6, 1.6)}
          initial="hidden"
          whileInView={"show"}
          className="flex justify-center items-center"
        >
          <p className="text-center text-white mt-4">{message}</p>
        </motion.div>
      </div>
    </section>
  );
};

export default Objective;
